import { render, staticRenderFns } from "./TheClase.vue?vue&type=template&id=3afffe64&scoped=true&"
import script from "./TheClase.vue?vue&type=script&lang=js&"
export * from "./TheClase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afffe64",
  null
  
)

export default component.exports